<template>
  <c-box>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Preskripsi Diet/Nutrition Prescription
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="text"
          error-border-color="red.300"
          placeholder="Masukkan Preskripsi Diet/Nutrition Prescription"
          height="62px"
          v-model="value.nutritionPrescription"
        />
      </c-input-group>
    </c-form-control>
    <c-form-control mb="18px">
      <c-form-label
        fontSize="14px"
        color="#555555"
        fontWeigh="400"
        fontFamily="Roboto"
      >
        Target Pencapaian/Goals (SMART)
      </c-form-label>
      <c-input-group size="md">
        <c-input
          type="text"
          error-border-color="red.300"
          placeholder="Masukkan Target Pencapaian/Goals (SMART)"
          height="62px"
          v-model="value.goal"
        />
      </c-input-group>
    </c-form-control>
  </c-box>
</template>

<script>
export default {
  name: "NutritionInterventionForm",
  props: ["value"],
}
</script>